import _ from 'lodash';
import { createSelector } from 'reselect';
import { LiveStreamListFilter } from '../../redux/reducers/live-streams/live-streams.reducer';

export const liveStreamAnalytics = (state) => state.liveStreamAnalytics;
export const liveStreams = (state) => state.liveStreams;

export const selectedLiveStreamsId = (state) => {
  return state.liveStreams.selectedLiveStreamId;
};

export const getSelectedLiveStream = createSelector(
  liveStreams,
  selectedLiveStreamsId,
  (liveStreams, selectedLiveStreamsId) =>
    _.find(liveStreams.streams, { id: selectedLiveStreamsId }),
);

export const getSelectedLiveStreamAnalytics = createSelector(
  liveStreamAnalytics,
  (liveStreamAnalytics) => liveStreamAnalytics,
);

export const getLiveStreams = createSelector(
  liveStreams,
  (liveStreams) => liveStreams.streams,
);

export const getLiveStreamsErrorCode = createSelector(
  liveStreams,
  (liveStreams) => liveStreams.errorCode,
);

export const hasMoreStreams = createSelector(liveStreams, (liveStreams) =>
  _.has(liveStreams, 'nextPageToken'),
);

export const getNextPageToken = createSelector(liveStreams, (liveStreams) =>
  _.get(liveStreams, 'nextPageToken'),
);

export const getLiveStreamFilter = createSelector(
  liveStreams,
  (liveStreams): LiveStreamListFilter =>
    _.get(liveStreams, 'stateFilter', LiveStreamListFilter.None),
);

export const isLoadingMore = createSelector(liveStreams, (liveStreams) =>
  _.get(liveStreams, 'isLoadingMore'),
);
